// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"dc8c6235","488":"085a07fd","823":"a8dd70cc"}[chunkId] + ".chunk.js";
};